import {Injectable, isDevMode} from '@angular/core';
import {MyCONST} from '../CONST/myCONST';

@Injectable()
export class UrlService {
  baseurl;
  socket_url;

  prod_url = MyCONST.BAS_URL;
  prod_url_multi = MyCONST.BAS_URL_MULTI;

  multi_site = MyCONST.MULTI_SITE;
  prod_socket = MyCONST.SOCKET_URL;
  prod_socket_multi = MyCONST.SOCKET_URL_MULTI;

  default_service_img = MyCONST.DEFAULT_IMG;
  default_img_url = MyCONST.DEFAULT_IMG;

  constructor() {
    console.log('prod_socket =====> ',this.prod_socket)
    const domain = new URL(window.location.origin).hostname;
    const element = domain.split('.');
    if ( this.multi_site === 1) {
      console.log('=======> domain ', domain );
      this.prod_url = this.prod_url_multi.replace('country_pays', element[1]);
      this.prod_socket = this.prod_socket_multi.replace('country_pays', element[1]);

    }

    if (isDevMode()) {

      this.baseurl = MyCONST.DEV_BAS_URL;
      this.socket_url = MyCONST.DEV_SOCKET_URL;
    } else {
      this.baseurl = this.prod_url;
      this.socket_url = this.prod_socket;
    }
  }

}
